import React, { useEffect, useState, Fragment } from "react";
import NavBar from "../../../components/NavBar/NavBar";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import {
  TextField,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  IconButton,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  makeStyles,
  Container,
} from "@material-ui/core";
import DefaultFeatureImage from "../../../assets/images/FeatureDefaultImage.jpeg";
import CopyRights from "../../../components/AppComponents/CopyRights";
import AppVersion from "../../../components/AppComponents/AppVersion";

const useStyles = makeStyles((theme) => ({
  mainContent: {
    minHeight: "calc(100vh - 145px)",
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(12),
  },
  searchBar: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  searchTextField: {
    width: "70%",
  },
  filters: {
    width: "70%",
    display: "flex",
    justifyContent: "start",
  },
  filtersContent: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  cardGrid: {
    maxWidth: "73%",
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
  },
  mainCard: {
    display: "flex",
    flexDirection: "row",
    cursor: "pointer",
  },
  cardMedia: {
    minWidth: "20%",
    height: "auto",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
  },
  cardContent: {
    flexGrow: 1,
    maxWidth: "70%",
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
    position: "relative",
    left: 0,
    bottom: 0,
    right: 0,
  },
}));

const HomePageV2 = () => {
  const classes = useStyles();

  const [searchText, setSearchText] = useState("");
  const [allData, setAllData] = useState([]);
  const [itemsData, setItemsData] = useState([]);
  const [foundData, setFoundData] = useState([]);

  let [isDashboardChecked, setIsDashboardChecked] = useState(0);
  let [isFormChecked, setIsFormChecked] = useState(0);
  let [isReportChecked, setIsReportChecked] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClearClick = () => {
    setSearchText("");
    setFoundData(itemsData);
  };

  useEffect(() => {
    const ckObject = localStorage.getItem("ckAdminUser") || "{}";
    const jsonCkObject = JSON.parse(ckObject) || {};
    const featureList = jsonCkObject.featureList || [];
    setAllData(featureList);
    let items = [];
    for (let i = 0; i < featureList.length; i++) {
      let featuresItems = featureList[i]["items"] || [];
      items = items.concat(featuresItems);
    }
    setItemsData(items);
    setFoundData(items);
  }, []);

  const filterData = (keyword, isDashboard, isForm, isReport) => {
    let results = [];

    for (let i = 0; i < allData.length; i++) {
      let category = allData[i];
      if (
        (!isDashboard && !isForm && !isReport) ||
        (category.typeId === 1 && isDashboard) ||
        (category.typeId === 2 && isForm) ||
        (category.typeId === 3 && isReport)
      ) {
        let categoryItems = category.items || [];
        for (let j = 0; j < categoryItems.length; j++) {
          let item = categoryItems[j];
          if (
            keyword === "" ||
            item.label.toLowerCase().includes(keyword.toLowerCase())
          )
            results.push(item);
        }
      }
    }
    setFoundData(results);
    setSearchText(keyword);
  };

  const updateFilters = (e) => {
    let filterValue = e.target.checked;
    let checkValue = filterValue ? 1 : 0;

    switch (e.target.name) {
      case "DashboardCheckbox":
        setIsDashboardChecked(checkValue);
        filterData(searchText, checkValue, isFormChecked, isReportChecked);
        break;
      case "FormCheckbox":
        setIsFormChecked(checkValue);
        filterData(searchText, isDashboardChecked, checkValue, isReportChecked);
        break;
      case "ReportCheckbox":
        setIsReportChecked(checkValue);
        filterData(searchText, isDashboardChecked, isFormChecked, checkValue);
        break;
      default:
        break;
    }
  };

  return (
    <Fragment>
      <NavBar isAuthorize />
      <main className={classes.mainContent}>
        <div className={classes.heroContent}>
          <div className={classes.searchBar}>
            <TextField
              id="search_textfield_id"
              className={classes.searchTextField}
              label="Search"
              variant="outlined"
              value={searchText}
              onChange={(event) =>
                filterData(
                  event.target.value,
                  isDashboardChecked,
                  isFormChecked,
                  isReportChecked
                )
              }
              InputProps={{
                endAdornment: (
                  <>
                    <InputAdornment position="end">
                      <IconButton
                        sx={{
                          visibility: searchText !== "" ? "visible" : "hidden",
                        }}
                        onClick={(event) => handleClearClick(event)}
                      >
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                    <InputAdornment position="start">
                      <IconButton
                        onClick={() =>
                          filterData(
                            searchText,
                            isDashboardChecked,
                            isFormChecked,
                            isReportChecked
                          )
                        }
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  </>
                ),
              }}
            />
          </div>

          <div className={classes.filtersContent}>
            <div className={classes.filters}>
              {" "}
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={isDashboardChecked === 1}
                    onChange={updateFilters}
                    name="DashboardCheckbox"
                  />
                }
                label="Dashboard"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={isFormChecked === 1}
                    onChange={updateFilters}
                    name="FormCheckbox"
                  />
                }
                label="Forms"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={isReportChecked === 1}
                    onChange={updateFilters}
                    name="ReportCheckbox"
                  />
                }
                label="Reports"
              />
            </div>
          </div>
        </div>
        <Container className={classes.cardGrid} maxWidth="md">
          <Grid container spacing={4}>
            {foundData.map((cardData) => {
              let imageSrc =
                cardData.thumbnailFileName && cardData.thumbnailFilePath
                  ? `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${cardData.thumbnailFilePath}/${cardData.thumbnailFileName}`
                  : DefaultFeatureImage;

              let cardDescription = cardData.description
                ? cardData.description
                : "N/A";
              let cardLabel = cardData.label ? cardData.label : "N/A";

              let onCardClick = () => {
                
                
                window.open("#".concat(cardData.webUrl), "_self");
              };

              return (
                <Grid
                  onClick={() => onCardClick()}
                  item
                  key={cardData.id}
                  xs={12}
                  sm={6}
                  md={4}
                >
                  <Card className={classes.mainCard}>
                    <CardMedia
                      className={classes.cardMedia}
                      image={imageSrc}
                      title={cardData.label}
                    />
                    <CardContent className={classes.cardContent}>
                      <Typography
                        style={{ fontWeight: 600 }}
                        noWrap
                        gutterBottom
                        component="h4"
                      >
                        {cardLabel}
                      </Typography>
                      <Typography noWrap variant="body2">
                        {cardDescription}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </Container>
      </main>
      <footer className={classes.footer}>
        <Typography
          variant="subtitle1"
          align="center"
          color="textSecondary"
          component="p"
        >
          Your destination to create your ideal albums
        </Typography>
        <CopyRights />
        <AppVersion />
      </footer>
    </Fragment>
  );
};

export default HomePageV2;
